import React from 'react';
import Button from './button';

class ButtonGridCell extends React.Component {

    clickHandler(e) {
        if (typeof this.props.onClick === 'function') {
            this.props.onClick(e, this.props.data, this.props.rowData);
        }
    }

    renderIcon(iconClass) {
        if (typeof iconClass === 'string' && iconClass.length > 0) {
            return (
                <span className={iconClass}></span>
            )
        } else {
            return null;
        }
    }

    render () {
        return (
            <span className="component-button-grid-cell">
                <Button {...this.props} onClick={e => this.clickHandler(e)}>
                    { this.props.text || this.renderIcon(this.props.icon) || this.props.data }
                </Button>
            </span>
        )
    }
}

export default ButtonGridCell;



// WEBPACK FOOTER //
// ./web-app/components/button-grid-cell.jsx